import { React, useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

import CTAButton from '../CTAButton/CTAButton.js'
import Skeleton from '../Skeleton/Skeleton.js'

import { lP, URL_MAINAPI, API_TOKEN } from '../../main.js'

import './AdminGuard.css'

import Cookies from 'universal-cookie'

/**
 * Zeigt children nur für Helferzeit-Admins (User.helferzeit_admin = 1).
 * Reine UI-Sperre – die MainAPI prüft die Rechte bei jedem Admin-Endpunkt selbst.
 */
export default function AdminGuard({ children }) {
    // 0 = lädt, 1 = Admin, -1 = kein Zugriff
    var [state, setState] = useState(0)

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    useEffect(() => {
        try {
            fetch(URL_MAINAPI + "/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                setState((res.status === 200 && res.data && res.data.helferzeit_admin == 1) ? 1 : -1)
            })).catch(() => setState(-1))
        } catch (err) {
            setState(-1)
        }
    }, [])

    if (state === 0) {
        return (
            <div className='card adminguard-card'>
                <Skeleton width="50%" height={20} />
                <Skeleton width="100%" height={16} />
            </div>
        )
    }

    if (state === -1) {
        return (
            <div className='card adminguard-card adminguard-denied'>
                <FontAwesomeIcon icon={faLock} />
                <h3>Kein Zugriff</h3>
                <p>Dieser Bereich ist nur für das interne Helferzeit-Team freigeschaltet.</p>
                <CTAButton variant="primary" hideArrow={false} title={"Zum Profil"} onclick={() => lP('/profil')} />
            </div>
        )
    }

    return children
}
